import React, { useState, useEffect } from 'react';
import ListOfAshas from '../../Dashboard/AshaAnmSection/AnmListOfAshas/ListOfAshas';
import ReusableTabView from '../../../Shared/Component/CustomReusableTab/ReusableTabView';
import { useDispatch, useSelector } from 'react-redux';
import * as masterSelectors from '../../../Store/Dashboard/AshaAnmSection/AnmSectionSelectors';
import AnmProfileView from './AnmProfileView/AnmProfileView';
import {
  fetchActivityandIncentive,
  fetchAnmProfile,
  fetchListOfAshas,
  fetchApprovedRequests,
} from '../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions';
import PropTypes from 'prop-types';
import { useLanguage } from '../../ChangeLanguage/LanguageProvider';
import { Avatar } from 'primereact/avatar';
import SendReminderView from '../../../Shared/Component/SendReminder/SendReminderView';
import { getSelectedDistrictId,getSendTaluka } from '../../../Store/Dashboard/DashboardSelectors';
const AnmIndividualView = ({ anmId, chosenActiveIndex = 0 }) => {
  const { selectedLanguageId } = useLanguage();
  const districtId = useSelector(getSelectedDistrictId);
  const talukaId = useSelector(getSendTaluka);
  const anmProfile = useSelector(masterSelectors.getAnmProfile);
  const listofAsha = useSelector(masterSelectors.getListOfAshas);
  const anmActivityIncentive = useSelector(
    masterSelectors.getAnmActivityIncentive
  );
  const allrequests = useSelector(masterSelectors.getapprovedPendingReq);
  const [profile, setProfile] = useState(anmProfile);
  const [ashaList, setAshaList] = useState(listofAsha);
  const [, setActivityIncentiveList] =
    useState(anmActivityIncentive);
  const [, setApprovedRequests] = useState(allrequests);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAnmProfile(anmId, selectedLanguageId));
    dispatch(fetchListOfAshas(anmId, selectedLanguageId,districtId,talukaId));
    dispatch(fetchActivityandIncentive(anmId));
    dispatch(fetchApprovedRequests(anmId));
  }, [anmId,dispatch,selectedLanguageId,districtId,talukaId]);

  useEffect(() => {
    setProfile(anmProfile);
  }, [anmProfile,profile,selectedLanguageId]);

  useEffect(() => {
    setActivityIncentiveList(anmActivityIncentive);
  }, [anmActivityIncentive]);

  useEffect(() => {
    setAshaList(listofAsha);
  }, [listofAsha]);

  useEffect(() => {
    setAshaList(listofAsha);
  }, [listofAsha]);

  useEffect(() => {
    setApprovedRequests(allrequests);
  }, [allrequests]);

  const tabs = [
    {
      header: 'Profile Details',
      content: <AnmProfileView anm={true} anmId={anmId} profile={profile} />,
    },
    {
      header: `ASHA List with Approved Incentive`,
      content: <ListOfAshas anmId={anmId} ashalist={ashaList} />,
    },
  ];
  function getInitials() {
    if (anmProfile && anmProfile.anmdetails && anmProfile.anmdetails.name) {
    return anmProfile.anmdetails.name.split(' ').map((part) => part.charAt(0)).join('');
     } else {
     return '';
   }
    }
    const initials = getInitials();
  return (
    <div className=''>
      <div className='flex align-items-center justify-content-between'>
        <div className='flex align-items-center' data-testid="anm-profile-header">
          <Avatar
            label={initials}
            className='mr-2'
            size='large'
            style={{ backgroundColor: '#2196F3', color: '#ffffff' }}
            shape='circle'
            data-testid="anm-avatar"
          />
          {anmProfile.anmdetails ? (
            <p className='text-xl font-light ml-2' data-testid="anm-name">
              {anmProfile.anmdetails.name}
            </p>
          ) : (
            <></>
          )}
        </div>
        <div data-testid="send-reminder-view">
          <SendReminderView ashaIds={[anmId]} isDisabled={false} />
        </div>
      </div>
      <ReusableTabView tabs={tabs} data-testid="reusable-tab-view"/>
    </div>
  );
};

AnmIndividualView.propTypes = {
  anmId: PropTypes.string.isRequired,
  chosenActiveIndex: PropTypes.number,
};

export default AnmIndividualView;
